import React, { useMemo, useState } from 'react';

// Painel lateral com todas as cameras: busca por nome, filtro por grupo e
// filial. Clicar abre a camera sozinha (HD).
export default function ListaCameras({ catalogo, onAbrir, onFechar }) {
  const [busca, setBusca] = useState('');
  const [grupo, setGrupo] = useState('');
  const [filial, setFilial] = useState('');

  const gruposPorId = useMemo(() => new Map(catalogo.grupos.map((g) => [g.id, g])), [catalogo.grupos]);
  const filiais = useMemo(
    () => [...new Set(catalogo.gravadores.map((g) => g.filial).filter(Boolean))].sort(),
    [catalogo.gravadores],
  );

  const secoes = useMemo(() => {
    const termo = busca.trim().toLowerCase();
    return [...catalogo.gravadores]
      .sort((a, b) => a.ordem - b.ordem || String(a.nome).localeCompare(String(b.nome), 'pt-BR'))
      .filter((g) => !filial || g.filial === filial)
      .map((g) => ({
        gravador: g,
        cameras: catalogo.cameras
          .filter((c) => c.gravador_id === g.id)
          .filter((c) => !grupo || String(c.grupo_id) === grupo)
          .filter((c) => !termo || `${c.nome} ${g.nome}`.toLowerCase().includes(termo))
          .sort((a, b) => a.ordem - b.ordem || a.canal - b.canal),
      }))
      .filter((s) => s.cameras.length);
  }, [catalogo, busca, grupo, filial]);

  return (
    <aside className="cameras-lista" aria-label="Lista de câmeras">
      <div className="cameras-lista__topo">
        <strong>Câmeras</strong>
        <button type="button" className="cameras-barra__btn" onClick={onFechar} title="Fechar a lista">
          <i className="bi bi-x-lg" />
        </button>
      </div>
      <div className="cameras-lista__filtros">
        <input
          type="search"
          placeholder="Buscar câmera ou equipamento"
          value={busca}
          onChange={(e) => setBusca(e.target.value)}
          autoFocus
        />
        <div style={{ display: 'flex', gap: 6 }}>
          <select value={grupo} onChange={(e) => setGrupo(e.target.value)} title="Grupo">
            <option value="">Todos os grupos</option>
            {catalogo.grupos.map((g) => <option key={g.id} value={g.id}>{g.nome}</option>)}
          </select>
          {filiais.length > 0 && (
            <select value={filial} onChange={(e) => setFilial(e.target.value)} title="Filial">
              <option value="">Todas as filiais</option>
              {filiais.map((f) => <option key={f} value={f}>Filial {f}</option>)}
            </select>
          )}
        </div>
      </div>

      <div className="cameras-lista__itens">
        {secoes.length === 0 && <p className="cameras-lista__vazio">Nenhuma câmera encontrada.</p>}
        {secoes.map(({ gravador, cameras }) => (
          <section key={gravador.id}>
            <h4 className="cameras-lista__equipamento">
              {gravador.nome}
              {gravador.filial ? <span> · Filial {gravador.filial}</span> : null}
            </h4>
            {cameras.map((c) => (
              <button key={c.id} type="button" className="cameras-lista__item" onClick={() => onAbrir(c)}>
                <i className="bi bi-camera-video" />
                <span className="cameras-lista__nome">{c.nome}</span>
                {c.grupo_id && gruposPorId.get(c.grupo_id) ? (
                  <span className="cameras-barra__tag">{gruposPorId.get(c.grupo_id).nome}</span>
                ) : null}
              </button>
            ))}
          </section>
        ))}
      </div>
    </aside>
  );
}
